import { render, staticRenderFns } from "./SelectSidebarDropdown.vue?vue&type=template&id=02c0cf78"
import script from "./SelectSidebarDropdown.vue?vue&type=script&lang=js"
export * from "./SelectSidebarDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports